import { render, staticRenderFns } from "./ProdutorProfile.vue?vue&type=template&id=592482b6"
import script from "./ProdutorProfile.vue?vue&type=script&lang=js"
export * from "./ProdutorProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports